/// <reference path="_references.ts"/>

module App.TimeEvent {
	export class TimeEventService {
		static $inject = ['$q', '$http', 'Constants', 'UserSession', 'PermissionService'];
		constructor(
			protected $q: ng.IQService,
			protected $http: ng.IHttpService,
			protected Constants: IConstants,
			protected UserSession: App.User.UserSession,
			protected PermissionService: App.Helpers.PermissionService
		) {
		}

		getTags(params?: any): ng.IHttpPromise<TimeEventTag[]> {
			return this.$http.get(`${this.Constants.apiUrl}timeeventtag`, {
				params: params || {},
			});
		}

		getTimeEvent(id: number, params?: any): ng.IHttpPromise<TimeEvent> {
			return this.$http.get(`${this.Constants.apiUrl}timeevent/${id}`, {
				params: params || {},
			});
		}

		getTimeEvents(params?: any): ng.IHttpPromise<TimeEvent[]> {
			return this.$http.get(`${this.Constants.apiUrl}timeevent`, {
				params: params || {},
			});
		}

		update(id: number, data: TimeEventUpdate, params?: any): ng.IHttpPromise<TimeEvent> {
			return this.$http.put(`${this.Constants.apiUrl}timeevent/${id}`, data, {
				params: params || {},
			});
		}

		create(data: TimeEventUpdate, params?: any): ng.IHttpPromise<TimeEvent> {
			return this.$http.post(`${this.Constants.apiUrl}timeevent`, data, {
				params: params || {},
			});
		}

		getLatestEvent(): ng.IPromise<TimeEvent> {
			if (!this.PermissionService.hasPermission('web.time-clock.field.view')) {
				return this.$q.when(null);
			}
			return this.UserSession.getUser()
				.then(user => this
					.getTimeEvents({
						user: user.id,
						size: 1,
						orderBy: 'date,id',
						sort: 'DESC',
					})
					.then(r => r && r.data && r.data.length && r.data[0] || null)
				);
		}

		confirmLastEvent(): ng.IPromise<any> {
			if (!this.PermissionService.hasPermission('web.time-clock.field.confirm')) {
				return this.$q.when(null);
			}
			return this.UserSession.getUser()
				.then(user => this.getTimeEvents({
					user: user.id,
					size: 2,
					orderBy: 'date,id',
					sort: 'DESC'
				}))
				.then(r => r && r.data && r.data.length > 1 && TimeEventEditController.confirmEvent(
					r.data[0],
					r.data[1]
				));
		}
	}
}
